import { RouteObject } from 'react-router-dom'

import { default as Billing } from '.'
import { PageLayout } from '../../../common/app'

export const billingRoutes: RouteObject[] = [
  {
    path: '/settings/billing',
    element: (
      <PageLayout
        title="Manage Billing"
        htmlTitleOnly
        alignMainContent="center"
      >
        <Billing.ManageBilling.Component />
      </PageLayout>
    ),
    loader: Billing.ManageBilling.Loader,
  },
]
